// extracted by mini-css-extract-plugin
export default {"blockThird":"thirdInfoBlock_blockThird__5LkNa","description":"thirdInfoBlock_description__vie14","data":"thirdInfoBlock_data__i6tn8"};